import { useState } from 'react';
import PropTypes from 'prop-types';

import TreeSelect from 'common/components/form/inputs/TreeSelect';
import { getInitialSingleValue } from 'common/utils/lists';
import SvgRender from 'common/components/general/SvgRender';
import arrow from 'common/assets/svg/common/arrow.svg';
import useTooltipID from 'common/utils/hooks/useTooltipID';
import { StoreGroup } from 'common/entities/purchasing/PurchasingRequisitionTypes';

const GroupField = ({
  onChange,
  label = 'GROUP',
  disabled = false,
  placeholder = 'Select group',
  endpoint = '/store-groups',
  storeGroup
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { avoidRender, tooltipID } = useTooltipID('select-group-popup');

  if (avoidRender) return;

  return (
    <div>
      <div className="form-label">{label}</div>
      <div
        id={tooltipID}
        className={`d-flex align-items-center justify-content-between border ${
          disabled ? 'light-gray pointer-events-none' : 'border-inactive'
        }  border-radius-base cps-12 cpe-12 cpt-2 cpb-2`}
      >
        <span
          className={`fs-12 fw-medium ${storeGroup.value?.id ? 'text-primary' : 'text-inactive'}`}
        >
          {storeGroup.value?.name || placeholder}
        </span>

        {disabled ? null : (
          <SvgRender
            src={arrow}
            style={{ width: 10, height: 10, transform: isOpen ? `rotate(180deg)` : '' }}
          />
        )}
      </div>

      <TreeSelect
        fetchOptions={params => getInitialSingleValue(endpoint, params)}
        initialFetchOptionsParams={
          storeGroup.value?.parent?.id
            ? { parent_id: storeGroup.value.parent.id }
            : { is_root: true }
        }
        initialHeader="GROUPS"
        target={tooltipID}
        isOpen={isOpen}
        toggle={() => setIsOpen(prev => !prev)}
        onSelect={onChange}
        initialSelectedOptionId={storeGroup.value?.id || null}
      />
    </div>
  );
};

export default GroupField;

GroupField.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string,
  endpoint: PropTypes.string,
  storeGroup: PropTypes.shape({
    value: StoreGroup
  })
};
